import React from "react";
import { FileWarning } from "lucide-react";

const SERVER_BG =
  "https://images.unsplash.com/photo-1695668548342-c0c1ad479aee?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwyfHxkYXJrJTIwc2VydmVyJTIwcm9vbSUyMHRlY2h8ZW58MHx8fHwxNzc5OTIxMDIxfDA&ixlib=rb-4.1.0&q=85";

const ARTICLES = [
  {
    id: "shadow-rank",
    tag: "Suppression",
    title: "The Quiet Demotion: How Shadow-Ranking Erases Small Businesses",
    excerpt:
      "Across major marketplaces, an undocumented secondary score determines whether your listings are ever shown — even when ads are paid in full.",
    read: "8 min read",
  },
  {
    id: "credit-models",
    tag: "Finance",
    title: "The Scorecard You'll Never See: Lending Algorithms in 2026",
    excerpt:
      "Credit decisions are now downstream of behavioral models you never consented to. Here is the architecture, in plain language.",
    read: "11 min read",
  },
  {
    id: "feed-throttle",
    tag: "Visibility",
    title: "Feed Throttling Is Not a Theory. It's a Pricing Tool.",
    excerpt:
      "Reach decay correlates with refusal to spend on platform-native ads. We mapped the curve across four major networks.",
    read: "6 min read",
  },
];

export default function Exposed() {
  return (
    <section
      id="exposed"
      data-testid="exposed-section"
      className="relative border-b border-white/10 py-24 md:py-32"
    >
      <div
        className="absolute inset-0 -z-10 opacity-25"
        style={{
          backgroundImage: `url(${SERVER_BG})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <div className="absolute inset-0 -z-10 bg-gradient-to-b from-black via-black/85 to-black" />

      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-16 reveal">
          <div className="lg:col-span-7">
            <div className="font-mono text-[11px] uppercase tracking-[0.32em] text-red-400 mb-6 inline-flex items-center gap-3">
              <FileWarning size={14} /> /02 — Exposed Files
            </div>
            <h2 className="font-heading text-4xl md:text-5xl font-bold uppercase tracking-tight leading-[0.95]">
              Field reports from
              <br />
              inside the <span className="text-red-500">machine.</span>
            </h2>
          </div>
          <div className="lg:col-span-5 flex lg:items-end">
            <p className="font-body text-base md:text-lg text-gray-300 leading-relaxed">
              Public-facing investigative briefings. Stripped of jargon, built for operators,
              founders, and the people whose livelihoods depend on systems they cannot see.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {ARTICLES.map((a, i) => (
            <article
              key={a.id}
              data-testid={`article-${a.id}`}
              className="bg-[#0a0a0a] p-8 md:p-10 group hover:bg-[#0f0f0f] transition-colors"
            >
              <div className="flex items-center justify-between mb-6">
                <span className="font-mono text-[10px] uppercase tracking-[0.28em] text-red-400">
                  File · 0{i + 1}
                </span>
                <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-gray-500">
                  {a.tag}
                </span>
              </div>
              <h3 className="font-heading text-xl md:text-2xl font-bold leading-tight text-white group-hover:text-red-400 transition-colors">
                {a.title}
              </h3>
              <p className="mt-5 font-body text-sm text-gray-400 leading-relaxed">
                {a.excerpt}
              </p>
              <div className="mt-8 flex items-center justify-between border-t border-white/10 pt-5">
                <span className="font-mono text-[10px] uppercase tracking-[0.24em] text-gray-500">
                  {a.read}
                </span>
                <a
                  href="#contact"
                  data-testid={`article-cta-${a.id}`}
                  className="font-mono text-[10px] uppercase tracking-[0.24em] text-white link-underline"
                >
                  Request Full Brief →
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
